module.exports = __webpack_public_path__ + "media/hyper/images/users/avatar-6-d98a113b0a21674ffd70a754735b7ecc.jpg";